import {useApp} from 'AppContext'
import {Block} from 'blocks/block'
import {BgFixed} from 'layout/partials/bg'
import {Theme} from 'layout/theme'
import React from 'react'
import {DPBackgroundblockBlock} from 'types/DPTypes'
import {fromModule} from 'util/styler/Styler'
import {useIDFromAnchorBlock} from 'util/useAnchor'
import css from './backgroundblock.module.scss'

const styles = fromModule(css)

export const BackgroundBlock: React.FC<DPBackgroundblockBlock> = (data) => {
	const {_type, background, text_left, text_right, dark} = data
	const {node} = useApp()
	const id = useIDFromAnchorBlock(data)

	const gradient = !background && !dark
	const pageType = node?._type
	const darkText = background?.use_dark_colors

	return (
		<Block
			type={_type}
			anchorID={id}
			className={styles.backgroundblock
				.mod(pageType)
				.mod({dark})
				.mod({gradient})
				.mod({darkText})()}
		>
			<BgFixed image={background} />
			<Theme.Container>
				<div className={styles.backgroundblock.content()}>
					<div className={styles.backgroundblock.row()}>
						<div className={styles.backgroundblock.row.col()}>
							<div className={styles.backgroundblock.content.left()}>
								{text_left && (
									<Theme.Wysiwyg mod={[pageType, 'inherit']}>
										{text_left}
									</Theme.Wysiwyg>
								)}
							</div>
						</div>
						<div className={styles.backgroundblock.row.col()}>
							<div className={styles.backgroundblock.content.right()}>
								{text_right && (
									<Theme.Wysiwyg mod={[pageType, 'inherit']}>
										{text_right}
									</Theme.Wysiwyg>
								)}
							</div>
						</div>
					</div>
				</div>
			</Theme.Container>
		</Block>
	)
}
